import React, { useState } from 'react'
import LoginLayout from './LoginLayout'
import SignInForm from './components/SignInForm'
import SignInWithGoogleButtonDEV from './components/SignInWithGoogleButtonDEV'
import TextField from '../../Components/GeneralComponents/TextField'
import AuthForm from './components/AuthForm'
import { ButtonOutline } from '../../Components/GeneralComponents/ButtonOutline/ButtonOutline'
import { isValidEmail } from '../../Helpers/isValidEmail'
import errorToast from '../../Components/Toasts/ErrorToast'
import { useAuth } from '../../Contexts/AuthContext'
import { useAPI } from '../../Contexts/APIContext'

const ADMIN_LOGIN = process.env.REACT_APP_ADMIN_LOGIN === 'true'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [isEmailSignIn, setIsEmailSignIn] = useState(false)
  const { loginWithGoogle, loginWithSAML, loginWithOAuth } = useAuth()
  const { getAuthProvidersOfEmail } = useAPI()

  const handleChange = event => {
    setEmail(event.target.value)
  }

  const handleSubmit = async event => {
    event.preventDefault()
    if (!isValidEmail(email)) {
      errorToast('Your email is not valid!')
      return
    }

    try {
      const response = await getAuthProvidersOfEmail(email)
      const providers = response ? response.identity_providers : []

      if (providers.length === 1 && providers[0].provider_type === 'password') {
        errorToast('There is no user with such email')
        return
      }

      const providerHandlers = {
        saml: async providerId => loginWithSAML(providerId),
        oidc: async providerId => loginWithOAuth(providerId),
        password: async () => setIsEmailSignIn(true),
        'google.com': async () => loginWithGoogle(),
      }

      const priorityOrder = ['saml', 'oidc', 'password', 'google.com']

      for (const type of priorityOrder) {
        const provider = providers.find(p => p.provider_type === type)
        if (!provider) continue

        const handler = providerHandlers[type]
        if (!handler) continue

        await handler(provider.provider_id)
        break
      }
    } catch (error) {
      if (!error.message.includes('(auth/popup-closed-by-user)'))
        errorToast("You haven't been invited")
    }
  }

  return (
    <LoginLayout>
      {!isEmailSignIn ? (
        <AuthForm title={'Login'} onSubmit={handleSubmit}>
          <div className="textfield-wrapper">
            <TextField
              label={'Email'}
              placeholder={'Enter email'}
              onChange={handleChange}
              value={email}
              name={'email'}
            />
          </div>
          <ButtonOutline
            disable={!isValidEmail(email)}
            text="continue"
            color="pink"
            type="submit"
          />
        </AuthForm>
      ) : (
        <SignInForm email={email} />
      )}
      {ADMIN_LOGIN && <SignInWithGoogleButtonDEV />}
    </LoginLayout>
  )
}
